import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { owner: String }

  connect() {
    try {
      const previous = sessionStorage.getItem("vending.public-draft.owner")
      if (this.ownerValue && previous !== this.ownerValue) this.clear()
      if (this.ownerValue) sessionStorage.setItem("vending.public-draft.owner", this.ownerValue)
    } catch { /* Storage is optional. */ }
  }

  leaving(event) {
    if (new URL(event.target.action, window.location.href).pathname === "/users/sign_out") this.clear()
  }

  clear() {
    window.dispatchEvent(new Event("public-drafts:clear"))
    try {
      Object.keys(sessionStorage).filter(key => key.startsWith("vending.public-draft."))
        .forEach(key => sessionStorage.removeItem(key))
    } catch { /* Storage is optional. */ }
  }
}
